import { ResourceLoader } from "@angular/compiler";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { Console } from "console";
import { AppyPractitionerCardInterface } from "src/app/core/model/v2/AppyPractitionerCardInterface";
import { HealthOrganizationSetupDomain } from "src/app/core/model/v2/practice/HealthOrganizationSetupDomain";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { UserService } from "src/app/core/services/v2/user.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { NotificationService } from "src/app/shared/notification-center/notification.service";

var nextId = 0;

@Component({
  selector: 'app-summary-list',
  templateUrl: './summary-list.component.html',
  styleUrls: ['./summary-list.component.scss']
})
export class SummaryListComponent implements OnInit {

  @Input() title: string = '---';
  @Input() items: UserSetup[];
  @Input() healthOrganizationSetup: HealthOrganizationSetupDomain;
  @Output() addItem: EventEmitter<any> = new EventEmitter();
  @Output() editItem: EventEmitter<UserSetup> = new EventEmitter();
  @Output() deleteItem: EventEmitter<UserSetup> = new EventEmitter();

  constructor(private router: Router, private userService: UserService, private loaderService: WindowLoaderService,
     private notificationService: NotificationService, private _matSnackBar : MatSnackBar) { }

  id = `summary-list-${nextId++}`;

  ngOnInit() {
    console.log(this.healthOrganizationSetup.healthOrganizationTypeId)
  }

  addItemClick() {
    this.addItem.emit();
  }

  editItemClick(item: UserSetup): void {
    this.editItem.emit(item);
  }

  deleteItemClick(item: UserSetup): void {
    this.deleteItem.emit(item);
  }

  displayName(item: UserSetup): string {
    if (item.practitioner)
      return item.practitioner.practiceName + ", " + item.practitioner.title
    else
      return item.name

  }

  redirectToProfile(item: UserSetup) {
    if (item.practitioner) {
      console.log(this.healthOrganizationSetup.healthOrganizationTypeId)
      if (item.practitioner.id > 0)
      if(this.healthOrganizationSetup.healthOrganizationTypeId==3)
        this.router.navigate(['/casemanager/profile', { id: item.practitioner.id ,practionerType:item.practitioner.practitionerType}]);
        else{
          this.router.navigate(['/physician/profile', { id: item.practitioner.id ,practionerType:item.practitioner.practitionerType}]);

        }
    }

  }

  displayRole(item: UserSetup): string {
    if (item.practitioner)
      return item.role
    else
      return item.role

  }
  toogleIsAdmin(item: UserSetup)
  {
    const giveOrREmove = item.isGlobalAdministrator ? "remove" : "give"; 

    this.notificationService.confirmation('Confirmation', `Are you sure you want to ${giveOrREmove} ${item.name} Global Administrator status ?`, 'No', 'Yes')
    .subscribe(
      _ => this.toogleUserIsAdmin(item)
    )

    // this.toogleUserIsAdmin(item);
  }

  private toogleUserIsAdmin(item: UserSetup) {
    this.loaderService.show();
    this.userService.toggleIsGlobalAdministratorFlag(item.id).subscribe(
      result => {
        if (result.resultStatus.isSuccess) {
          item.isGlobalAdministrator = result.result;
        }
      },
      (error) => {this.loaderService.hide();
        console.error(error);
        this._matSnackBar.open(error.error.message,"Ok");
      },
      () => this.loaderService.hide()
    );
  }

  getPractitionerCardModel(item: UserSetup): AppyPractitionerCardInterface {
    if (item.practitioner)
      return <AppyPractitionerCardInterface>
        {
          birthDate: item.practitioner.birthDate,
          gender: item.practitioner.gender,
          photoUrl: item.practitioner.photoUrl,
          practitionerId: item.practitioner.id,
          practitionerName:item.practitioner.practitionerName
        }

  }
}

